import { initChannels } from './channels';
import { AjvJsonValidator } from './validator';
import { apiDefinition } from './api';
export class Router {
    constructor(apiClient) {
        this._activeChannels = {};
        this._validator = new AjvJsonValidator();
        this.channels = initChannels(apiClient, this._validator);
    }
    getChannel(channel, parameters) {
        if (!apiDefinition.channels[channel])
            throw Error(`Channel ${channel} not exist in Async API definition`);
        if (!this._activeChannels[channel])
            this._activeChannels[channel] = this.channels[channel](parameters);
        return this._activeChannels[channel];
    }
}
